import { Component, inject } from '@angular/core';
import { SoilMeasurementTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilMeasurementTypeCreateDto,
  SoilMeasurementTypeDto,
  SoilMeasurementTypeExcelDownloadDto,
  SoilMeasurementTypeUpdateDto,
} from '../proxy/planning/dtos/soil-measurement-type';
import { SOILMEASUREMENTTYPE_CONFIG, SOILMEASUREMENTTYPE_FIELDS } from './soil-measurement-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-measurement-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilMeasurementTypeService, ConfirmationService],
  templateUrl: './soil-measurement-type.html',
  styleUrl: './soil-measurement-type.scss',
})
export class SoilMeasurementType extends BaseCrudComponent<
  SoilMeasurementTypeDto,
  SoilMeasurementTypeCreateDto,
  SoilMeasurementTypeUpdateDto,
  SoilMeasurementTypeExcelDownloadDto
> {
  service = inject(SoilMeasurementTypeService);
  config = SOILMEASUREMENTTYPE_CONFIG;
  fields = SOILMEASUREMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilMeasurementTypeDto): SoilMeasurementTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      soilSpecieId: data.soilSpecieId,
      unitOfMeasureId: data.unitOfMeasureId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilMeasurementType';
  }
}
